interface ImageAnalysis {
  isValid: boolean;
  warnings: {
    size?: string;
    format?: string;
    aspectRatio?: string;
  };
}

function analyzeImage(file: File, dimensions: { width: number; height: number }): ImageAnalysis {
  const analysis: ImageAnalysis = {
    isValid: true,
    warnings: {},
  };

  // Check file size (minimum 2400px on shortest side for good print quality)
  const minDimension = Math.min(dimensions.width, dimensions.height);
  if (minDimension < 2400) {
    analysis.isValid = false;
    analysis.warnings.size = 'Too Small';
  }

  // Check aspect ratio (shouldn't be too extreme, e.g. 1:10)
  const aspectRatio = dimensions.width / dimensions.height;
  if (aspectRatio > 10 || aspectRatio < 0.1) {
    analysis.isValid = false;
    analysis.warnings.aspectRatio = 'Unusual Ratio';
  }

  // Check format (should be one of the supported formats)
  const supportedFormats = ['image/jpeg', 'image/png', 'image/webp'];
  if (!supportedFormats.includes(file.type)) {
    analysis.isValid = false;
    analysis.warnings.format = 'Wrong Format';
  }

  return analysis;
}

function formatAspectRatio(width: number, height: number): string {
  const gcd = (a: number, b: number): number => (b ? gcd(b, a % b) : a);
  const divisor = gcd(width, height);
  const simplifiedWidth = width / divisor;
  const simplifiedHeight = height / divisor;

  // If the ratio is too complex (numbers too large), return decimal format
  if (simplifiedWidth > 20 || simplifiedHeight > 20) {
    return `${(width / height).toFixed(2)}:1`;
  }

  return `${Math.round(simplifiedWidth)}:${Math.round(simplifiedHeight)}`;
}

export { analyzeImage, formatAspectRatio };
export type { ImageAnalysis };
